import React, { useState, useEffect } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const EmailEditModal = ({ template, isOpen, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    title: '',
    category: '',
    subject: '',
    previewText: '',
    bodyContent: '',
    ctaText: '',
    description: ''
  });

  useEffect(() => {
    if (template) {
      setFormData({
        title: template?.title || '',
        category: template?.category || '',
        subject: template?.subject || '',
        previewText: template?.previewText || '',
        bodyContent: template?.bodyContent || '',
        ctaText: template?.ctaText || '',
        description: template?.description || ''
      });
    }
  }, [template]);

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSave({ ...template, ...formData });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card border border-border rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <h2 className="text-xl font-semibold text-foreground">Edit Email Template</h2>
          <button
            onClick={onClose}
            className="text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Close modal"
          >
            <Icon name="X" size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Title</label>
            <Input
              type="text"
              value={formData?.title}
              onChange={(e) => handleChange('title', e?.target?.value)}
              placeholder="Email template title"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Category</label>
            <select
              value={formData?.category}
              onChange={(e) => handleChange('category', e?.target?.value)}
              className="w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
              required
            >
              <option value="technology">Technology</option>
              <option value="educational">Educational</option>
              <option value="trust">Trust Building</option>
              <option value="seasonal">Seasonal</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Subject Line</label>
            <Input
              type="text"
              value={formData?.subject}
              onChange={(e) => handleChange('subject', e?.target?.value)}
              placeholder="Email subject line"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Preview Text</label>
            <Input
              type="text"
              value={formData?.previewText}
              onChange={(e) => handleChange('previewText', e?.target?.value)}
              placeholder="Preview text that appears in inbox"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Email Body</label>
            <textarea
              value={formData?.bodyContent}
              onChange={(e) => handleChange('bodyContent', e?.target?.value)}
              placeholder="Full email body content"
              rows={10}
              className="w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary resize-y"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Call to Action</label>
            <Input
              type="text"
              value={formData?.ctaText}
              onChange={(e) => handleChange('ctaText', e?.target?.value)}
              placeholder="CTA button text"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Description</label>
            <textarea
              value={formData?.description}
              onChange={(e) => handleChange('description', e?.target?.value)}
              placeholder="Brief description of this template"
              rows={3}
              className="w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary resize-y"
              required
            />
          </div>

          <div className="flex items-center justify-end gap-3 pt-4 border-t border-border">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="default"
            >
              Save Changes
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailEditModal;